import {GanttChartColorConfig} from '@hconnect/ganttchart/src/types/common'
import {AssetConfigurationDto} from '@kilnfeature/types'

export const kilnColors = {
  default: '#fff',
  station: '#D9E9F9',
  drive: '#D9F0EF',
  outline: '#29333D',
  mortar: '#000'
}

export const mapColorConfig = (
  kilnConfig: AssetConfigurationDto,
  stepWidth: number,
  rowIds: number[] | undefined = []
) => {
  const colorConfig: GanttChartColorConfig[] = []

  const driveDimensions = kilnConfig.payload.layout.drive.dimensions

  if (driveDimensions.distanceFrom0 !== undefined && driveDimensions.width !== undefined) {
    colorConfig.push({
      from: driveDimensions.distanceFrom0,
      to: driveDimensions.distanceFrom0 + driveDimensions.width,
      color: kilnColors.drive,
      rowIds: rowIds
    })
  }

  const kilnStations = kilnConfig.payload.layout.stations

  kilnStations.forEach((station) => {
    if (station.dimensions.distanceFrom0 !== undefined && station.dimensions.width !== undefined) {
      colorConfig.push({
        from: station.dimensions.distanceFrom0,
        to: station.dimensions.distanceFrom0 + station.dimensions.width,
        color: kilnColors.station,
        rowIds: rowIds
      })
    }
  })

  const kilnLength = Number(kilnConfig.payload.configuration.dimensions.length)
  let prevConfig: GanttChartColorConfig | undefined = undefined
  colorConfig.sort((a, b) => a.from - b.from)
  const colorConfigBaseLength = colorConfig.length

  colorConfig.forEach((config, index) => {
    const isLastConfig = index === colorConfigBaseLength - 1
    // fill the starting gap
    if (!prevConfig && config.from !== 0) {
      colorConfig.push({
        from: 0,
        to: config.from,
        color: kilnColors.default,
        rowIds
      })
    }

    // fill gaps between configs
    if (prevConfig && prevConfig.to !== config.from) {
      colorConfig.push({
        from: prevConfig.to,
        to: config.from,
        color: kilnColors.default,
        rowIds
      })
    }

    // fill the ending gap
    if (isLastConfig && config.to !== kilnLength) {
      colorConfig.push({
        from: config.to,
        to: kilnLength,
        color: kilnColors.default,
        rowIds
      })
    }

    prevConfig = config
  })

  // if colorConfig is empty, add the default color
  if (colorConfig.length === 0) {
    colorConfig.push({
      from: 0,
      to: kilnLength,
      color: kilnColors.default,
      rowIds
    })
  }

  return colorConfig
    .map((config) => ({
      ...config,
      from: config.from * stepWidth,
      to: config.to * stepWidth
    }))
    .sort((a, b) => a.from - b.from)
}
